import React, { useState, useEffect } from "react";
import {io} from "socket.io-client";
import { useSelector } from "react-redux";

const SocketContext = React.createContext(null);

export const SocketProvider = ({ children }) => {
  const poData = useSelector((state) => state.po.user);
  const hrData = useSelector((state) => state.hr.user)

  const userId = poData?.data?.id || hrData?.id;
  const [socket, setSocket] = useState(null);


  // Initialize Socket.IO connection
  useEffect(() => {
    if (!userId) return;

    const socketClient = io(process.env.REACT_APP_API_URL);

    socketClient.on("connect", () => {
      // console.log("Connected to Socket.IO Server");

      // Join user's room
      socketClient.emit("CREATEROOM", userId, (response) => {
        console.log("Room Join Response:", response);
      });
    });

    socketClient.on("disconnect", () => {
      console.warn("Disconnected from Socket.IO Server");
    });

    setSocket(socketClient);

    // Cleanup on unmount
    return () => {
      socketClient.disconnect();
    };
  }, [userId]);

  const contextValue = {
    socket
  };

  return <SocketContext.Provider value={contextValue}>{children}</SocketContext.Provider>;
};

// Custom hook to use socket context
export const useSocketContext = () => {
  const context = React.useContext(SocketContext);
  if (!context) {
    throw new Error("useSocketContext must be used within a SocketProvider");
  }
  return context;
};

export default SocketProvider;
